import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireSuperUser?: boolean;
  allowAdmin?: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  children, 
  requireSuperUser = false,
  allowAdmin = false
}) => {
  const { isAuthenticated, isSuperUser, isAdminUser } = useAuth();

  // Se não estiver autenticado, redireciona para login
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Se a rota requer SuperUser mas o usuário não é SuperUser
  if (requireSuperUser && !(isSuperUser || (allowAdmin && isAdminUser))) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;